module.exports = __webpack_public_path__ + "static/media/Red-Rock.cc7a1558.jpg";